import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authService from './authService';

// Check if the user is authenticated

const token = localStorage.getItem('token');
let saveUser = null;
if (token) {
	const tokenParts = token.split('.');
	if (tokenParts.length < 2) {
		console.error('Invalid token format');
	} else {
		const t = tokenParts[1];
		try {
			saveUser = t ? JSON.parse(atob(t)) : null;
		} catch (error) {
			console.error('Error decoding token:', error);
		}
	}
}

export const signOut = createAsyncThunk('/signout', async () => {
	await authService.signOut();
	return;
});

// export const getCartData = createAsyncThunk('/getCartData', async () => {
// 	const response = await authService.getCartData();
// 	return response;
// });

export const getCartData = createAsyncThunk('cart/getCartData', async () => {
	const cartData = localStorage.getItem('CartData');
	return cartData ? JSON.parse(cartData) : [];
});

export const addToCart = createAsyncThunk('/addtocart', async (product) => {
	const response = await authService.addToCart(product);
	return response;
});

export const updateCart = createAsyncThunk('/updatecart', async (product) => {
	const updatedCart = product.updatedCart;
	const response = await authService.updateCart(updatedCart);
	return response;
});

export const deleteCartData = createAsyncThunk('/deleteCartData', async (ArticleId) => {
	const response = await authService.deleteCartData(ArticleId);
	return response;
});

// Slice for Admin Login
export const signin = createAsyncThunk('/signin', async (userData, thunkAPI) => {
	try {
		const response = await authService.signin(userData);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		if (error?.response?.data?.status === 404) {
			localStorage.clear();
		}
		return thunkAPI.rejectWithValue(message);
	}
});

export const getAdmin = createAsyncThunk('/getAdmin', async (thunkAPI) => {
	try {
		const response = await authService.getAdmin();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getUser = createAsyncThunk('/getUser', async (thunkAPI) => {
	try {
		const response = await authService.getUser();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const FetchUser = createAsyncThunk('/FetchUser', async ({ page, data }, thunkAPI) => {
	try {
		const response = await authService.Fetchuser(data, page);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const changePassword = createAsyncThunk('/changepassword', async (data, thunkAPI) => {
	try {
		const response = await authService.changePassword(data);
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

const cartData = JSON.parse(localStorage.getItem('CartData')) || [];
const initialState = {
	auth: saveUser ? saveUser : null,
	user: null,
	data: [],
	cartData: cartData,
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		reset2: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
		resetMessage: (state) => {
			state.message = '';
		},
	},

	extraReducers: (builder) => {
		builder
			.addCase(signOut.fulfilled, (state) => {
				state.user = null;
				state.auth = null;
				state.isLoading = false;
				state.isSuccess = true;
				state.isError = false;
			})
			.addCase(getAdmin.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAdmin.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.user = action.payload.decryptedData;
				state.isError = false;
			})
			.addCase(getAdmin.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getUser.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getUser.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.user = action.payload.decryptedData;
				state.isError = false;
			})
			.addCase(getUser.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(changePassword.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(changePassword.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.message = action.payload.message;
				state.isError = false;
			})
			.addCase(changePassword.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(FetchUser.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(FetchUser.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.data = action.payload.data;
				state.isError = false;
			})
			.addCase(FetchUser.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getCartData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getCartData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.cartData = action.payload;
				state.isError = false;
			})
			.addCase(getCartData.rejected, (state) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = 'Error getting Cart Data';
			})
			.addCase(addToCart.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(addToCart.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.cartData = action.payload;
				state.isError = false;
			})
			.addCase(addToCart.rejected, (state) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = 'Error Adding Cart Data';
			})
			.addCase(updateCart.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(updateCart.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.cartData = action.payload;
				state.isError = false;
			})
			.addCase(updateCart.rejected, (state) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = 'Error Adding Cart Data';
			})
			.addCase(deleteCartData.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(deleteCartData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.cartData = action.payload;
				state.isError = false;
			})
			.addCase(deleteCartData.rejected, (state) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = 'Error Deleting Cart Data';
			});
	},
});

export const { reset2, resetMessage } = authSlice.actions;
export default authSlice.reducer;
